import { createCrudPage } from './factories/crud-page.js';

const basePath = '/company';

export default createCrudPage({
  title: 'Companies',
  basePath,
  columns: [
    { key: 'company_name', label: 'Company', sortable: true },
    { key: 'company_nameform', label: 'Brand', sortable: true },
    { key: 'key_accounts_list', label: 'Key Accounts' },
    { key: 'katalog_portal_end', label: 'Portal End', sortable: true },
    { key: 'company_log', label: 'Active', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'company_name', label: 'Company name', type: 'text', required: true },
    { key: 'company_nameform', label: 'Brand name', type: 'text' },
    { key: 'company_log', label: 'Active', type: 'yesno', defaultValue: '0' },
    { key: 'clients_pid', label: 'Client', type: 'async-select',
      optionsUrl: '/clients/options',
      placeholder: 'Select client' },
    { key: 'companytype_id', label: 'Sector', type: 'async-select',
      optionsUrl: '/company-types/options',
      iconProp: 'icon',
      placeholder: 'Choose Sector' },
    { key: 'company_franchising', label: 'Franchising type', type: 'async-select',
      optionsUrl: '/company-franchising-types/options',
      placeholder: 'Choose offer type' },
    { key: 'katalog_woj', label: 'Region', type: 'async-select',
      optionsUrl: '/regions/options',
      placeholder: 'Choose Region' },
    { key: 'company_address', label: 'Address', type: 'text' },
    { key: 'company_city', label: 'City', type: 'text' },
    { key: 'company_zip', label: 'ZIP', type: 'text' },
    { key: 'company_phone', label: 'Phone', type: 'text' },
    { key: 'company_email', label: 'Email', type: 'text' },
    { key: 'company_www', label: 'Website', type: 'text' },
    { key: 'company_text', label: 'Description', type: 'rich-text' },
    { key: 'company_text_short', label: 'Short description', type: 'textarea' },
    { key: 'square', label: 'Logo', type: 'file', accept: 'image/*', photo: true },
    { key: 'gallery', label: 'Gallery', type: 'file', multiple: true, accept: 'image/*', photo: true },
    { key: 'videos', label: 'YouTube Videos', type: 'videos',
      fieldInfo: 'Add YouTube videos with optional title and description. Drag to reorder.' },
    { key: 'minimal_investment', label: 'Minimal investment', type: 'text' },
    { key: 'own_capital', label: 'Own capital', type: 'text' },
    { key: 'total_investment', label: 'Total investment', type: 'text' },
    { key: 'franchise_fee', label: 'Franchise fee', type: 'text' },
    { key: 'royalty_fee', label: 'Royalty fee', type: 'text' },
    { key: 'number_outlets', label: 'Number of outlets', type: 'text' },
    { key: 'year_founded', label: 'Year founded', type: 'text' },
    { key: 'year_franchising', label: 'Franchising since', type: 'text' },
    { key: 'contract_length', label: 'Contract length', type: 'text' },
    { key: 'katalog_portal_start', label: 'Portal start', type: 'datetime' },
    { key: 'katalog_portal_end', label: 'Portal end', type: 'date' },
    { key: 'katalog_magazyn_start', label: 'Magazine start', type: 'async-select',
      optionsUrl: '/book-magazine-editions/options',
      placeholder: 'Magazine start' },
    { key: 'katalog_magazyn_end', label: 'Magazine end', type: 'async-select',
      optionsUrl: '/book-magazine-editions/options',
      placeholder: 'Magazine end' },
    { key: 'magazine_description', label: 'Magazine description', type: 'text', maxLength: 99 },
    { key: 'magazine_own', label: 'Magazine own outlets', type: 'text', maxLength: 29 },
    { key: 'magazine_franchisees', label: 'Magazine franchisees', type: 'text', maxLength: 29 },
    { key: 'magazine_investment', label: 'Magazine investment', type: 'text', maxLength: 49 },
    { key: 'magazine_place', label: 'Magazine place', type: 'text', maxLength: 99 },
    { key: 'magazine_person', label: 'Magazine contact person', type: 'text', maxLength: 39 },
    { key: 'magazine_phone', label: 'Magazine phone', type: 'text', maxLength: 39 },
    { key: 'magazine_email', label: 'Magazine email', type: 'text', maxLength: 49 },
    { key: 'seo_title', label: 'SEO Title', type: 'text' },
    { key: 'seo_description', label: 'SEO Description', type: 'textarea' },
    { key: 'seo_keywords', label: 'SEO Keywords', type: 'text' },
    { key: 'video', label: 'Video link', type: 'text' },
  ],
  filters: [
    { key: 'searchBrand', label: 'Brand', type: 'text' },
    { key: 'companyType', label: 'Sector', type: 'select',
      optionsUrl: '/company-types/options' },
    { key: 'bussinesType', label: 'Business Type', type: 'select',
      optionsUrl: '/company-franchising-types/options' },
    { key: 'keyAccounts', label: 'Key Accounts', type: 'select',
      optionsUrl: '/users-admin/options' },
    { key: 'active', label: 'Active', type: 'radio',
      options: [
        { value: '', label: 'All' },
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' },
      ] },
    { key: 'dateFrom', label: 'Date From', type: 'date' },
    { key: 'dateTo', label: 'Date To', type: 'date' },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'activate', label: 'Activate', icon: 'activate',
      confirm: 'Are you sure you want to activate this company?',
      visible: (row) => row.company_log == 0 },
    { key: 'deactivate', label: 'Deactivate', icon: 'deactivate',
      confirm: 'Are you sure you want to deactivate this company?',
      visible: (row) => row.company_log == 1 },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  customActions: (ctx) => ({
    activate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { company_log: 1 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    deactivate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { company_log: 0 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
  }),
  defaultSort: { field: 'company_name', dir: 'asc' },
});
